export default __webpack_public_path__ + "static/media/sustainability8.df3a6f78.webp";